// extracted by mini-css-extract-plugin
export default {"modal":"hVzIWVVkKJ1z7P435mmH","floating":"lWGd62rX9G4NWfzyUGTU","header":"KbMrB1qSyPEpjoz8ucaj","footer":"dt7PpbolMCa4XFyflEuR"};